import { useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { Colors } from '../../../constants/Colors'
import style from './Header.module.css'
import { Strings } from '../../../constants/Strings'

const Header = () => {
    
    const language = useAppSelector<string>(state => state.language.language)
    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme].app
            }}
        >
            <h1
                className={style.title}
                style={{
                    cursor: "pointer",
                    color: isHover ? Colors[theme].inActiveTint : Colors[theme].activeTint,
                    transition: "all 0.2s"
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {Strings[language ?? 'tm'].app}
            </h1>
        </div>
    )
}

export default Header
